import { AuthPartialState } from 'users/reducers/auth';
import { AffiliateUser } from 'types/user';
import { AffiliatesConfigPartialState } from 'common/types';
import smartPopunders from 'common/reducers/smartPopunders';
import { EmailVerificationPartialState } from 'users/reducers/emailVerification';
import { PayoutSettingsPartialState } from 'users/reducers/payoutSettings';

import config from './config';
import popunders from './popunders';
import whiteLabels from './whiteLabels';
import secrets from './secrets';
import contactUs, { ContactUsStateType } from './contactUs';

export type AffiliatesUnionState = AffiliatesConfigPartialState &
  AuthPartialState<AffiliateUser> &
  EmailVerificationPartialState &
  PayoutSettingsPartialState & {
    contactUs: ContactUsStateType;
  };

export default {
  config,
  popunders,
  smartPopunders,
  whiteLabels,
  secrets,
  contactUs,
};
